import Entity from './entity'
export default class PostBase extends Entity<number>{
    title:string;
    content:string;
    shortDescription:string;
    tagDescription:string;
    tenantId:number;

    constructor() {
        super();
  	}
}